var $dafcd55d52b9d371$exports = {};
$dafcd55d52b9d371$exports = {
  "decrease": function decrease(args) {
    return "".concat(args.fieldLabel, "\u3092\u7E2E\u5C0F");
  },
  "increase": function increase(args) {
    return "".concat(args.fieldLabel, "\u3092\u62E1\u5927");
  },
  "numberField": "\u6570\u5024\u30D5\u30A3\u30FC\u30EB\u30C9"
};
export { $dafcd55d52b9d371$exports as default };